// imports
import React, { useState } from 'react';

import Account from './account';
import EmptyList from '../../../molecules/list/empty';
import Topbar from '../../../molecules/tabView/topbar';
import ScrollableContainer from '../../../atoms/container/scrollable';

// interfaces / types / consts
type Section = 'account' | 'notifications' | 'advanced';

// exports
export default function Settings(): JSX.Element {
  const [section, setSection] = useState<Section>('account');
  const content = (section === 'account') ? <Account /> : <EmptyList text="Coming Soon" />;
  return (
    <div style={{ height: '100%' }}>
      <Topbar tabs={[
        { key: 'account', onClick: () => setSection('account') },
        { key: 'notifications', onClick: () => setSection('notifications') }
      ]}
      />
      <ScrollableContainer>{content}</ScrollableContainer>
    </div>
  );
}
